import mobileAds from './injectMobileAds';

export default [
  ...mobileAds,
];
